export const initialFormData = {
  OrganizationDescription: {
    contact_information: {
      contact_surname: "Smith",
      contact_first_name: "John",
      street_address: "1730 Lorem Ipsum St",
      phone_cell: "+15105525022",
      email: "johnsmith@abc.com",
      websites: "abc.com",
    },
    organization_description: {
      general_description:
        "Aliquam non placerat ipsum. Sed convallis diam eu ligula scelerisque, non pretium magna ultrices. In bibendum, sem nec semper rhoncus, sapien massa finibus purus, at consectetur sapien lacus nec purus. Integer sed lectus massa. Donec gravida ultrices purus, a efficitur orci dignissim eget. Cras euismod libero id elit posuere, vitae maximus urna commodo. Suspendisse potenti. Donec eu nunc odio.",
      total_sites_included: "8",
      status: "Under SCS Review",
    },
  },
  ConfirmationOfChanges: {
    auditRecords: [
      {
        auditType: "",
        descriptionOfChanges: "",
        auditorName: "",
      },
      {
        auditType: "",
        descriptionOfChanges: "",
        auditorName: "",
      },
      {
        auditType: "",
        descriptionOfChanges: "",
        auditorName: "",
      },
      {
        auditType: "",
        descriptionOfChanges: "",
        auditorName: "",
      },
    ],
  },
  CertificateScope: {
    FSC: {
      selectedScope: "Forest Stewardship Council (FSC)",
      issueDate: "1 June 2024",
      expiryDate: "1 June 2024",
      chainOfCustodyCode: "SCS-COC-12345",
      controlledWoodCode: "SCS-CW-12345",
      trademarkLicenseCode: "FSC-C12345",
      applicableStandards: ["FSC-STD-40-003 - Multiple Sites/Group"],
    },
    PEFC: {
      selectedScope: "",
      issueDate: "",
      expiryDate: "",
      chainOfCustodyCode: "",
      applicableStandards: [],
    },
    SFI: {
      selectedScope: "",
      issueDate: "",
      expiryDate: "",
      chainOfCustodyCode: "",
      certifiedSourcingCode: "",
      applicableStandards: [],
    },
    otherScheme: {
      selectedScope: "",
      issueDate: "",
      expiryDate: "",
      schemeName: "",
      certifiedCode: "",
      scopeDescription: "",
      applicableStandards: "",
    },
  },
  FscProductGroupList: {
    isNotApplicable: false,
    productGroupsComparison: {
      noChanges: false,
      changesRequired: false,
      notApplicable: false,
    },
    pglOptions: {
      orgProductList: false,
      recordProvidedBychecked: false,
      fileName: "",
    },
    pglrows: [
      {
        productCodeL1: "loreum1",
        productCodeL2: "",
        speciesCommonName: "",
        speciesLatinName: "",
        primaryActivity: "",
        secondaryActivity: "",
        fscOutputClaim: ["loreum1", "loreum2"],
      },
      {
        productCodeL1: "",
        productCodeL2: "",
        speciesCommonName: "",
        speciesLatinName: "",
        primaryActivity: "",
        secondaryActivity: "",
        fscOutputClaim: ["loreum1"],
      },
      {
        productCodeL1: "",
        productCodeL2: "",
        speciesCommonName: "",
        speciesLatinName: "",
        primaryActivity: "",
        secondaryActivity: "",
        fscOutputClaim: [],
      },
      {
        productCodeL1: "",
        productCodeL2: "",
        speciesCommonName: "",
        speciesLatinName: "",
        primaryActivity: "",
        secondaryActivity: "",
        fscOutputClaim: [],
      },
    ],
  },
  PeFcsfiRwProductCategories: {
    isNotApplicable: false,
    productGroupsComparison: {
      noChanges: false,
      changesRequired: false,
      notApplicable: false,
    },
  },
  ReclaimedMaterialsInfo: {
    isNotApplicable: false,
    description: "",
  },
  MultiSiteGroupInfo: {
    isNotApplicable: false,
    description: "",
    siteInformation: [
      {
        title: "Management system",
        description: "",
      },
      {
        title: "Material sourcing",
        description: "",
      },
      {
        title: "Management of non-conformities",
        description: "",
      },
      {
        title: "Site relationships, addition/removal process",
        description: "",
      },
    ],
  },
  fscAafData: {
    isNotApplicable: false,
    groupCertificationCheckbox: {
      checked: false,
      label: "N/A, Group Certification (see separate spreadsheet for values)",
    },
    fiscalYear: {
      startDate: "1/1/23",
      endDate: "12/31/23",
    },
    fscAafData: {
      FPT: {
        label: "Forest Products Turnover (FPT)",
        localCurrencyFigures: "",
        localCurrencyUnits: "",
        usDollarsFigures: "",
      },
      TR: {
        label: "Total Revenue (TR)",
        localCurrencyFigures: "",
        localCurrencyUnits: "",
        usDollarsFigures: "",
      },
    },

    financialDataConditions: [
      {
        label: "Both FPT and TR are provided AND both are reasonable.",
        checked: true,
      },
      {
        label:
          "FPT is provided but TR is not provided (or TR is not reasonable)",
        checked: false,
      },
      {
        label:
          "TR is provided but FPT is not provided (or FPT is not reasonable)",
        checked: false,
      },
      {
        label: "FPT and TR are provided BUT both are NOT reasonable:",
        checked: false,
      },
      {
        label: "Financial data is NOT provided.",
        checked: false,
      },
    ],
  },
  SummaryOfAssessment: {
    auditorCertificationRecommendation: {
      FSC: "",
      PEFC: "",
      SFI: "",
      Other: "",
      CertificationNotRecommended: {
        FSC: {
          value: "",
        },
        PEFC: {
          value: "",
          comment: "If certification is not recommended, please comment:",
        },
        SFI: {
          value: "",
          comment: "If certification is not recommended, please comment:",
        },
        Other: {
          value: "",
          comment: "If certification is not recommended, please comment:",
        },
      },
    },
    certificationDecision: {
      FSC: "",
      PEFC: "",
      SFI: "",
      Other: "",
    },
    dates: {
      certificationDecisionDate: "1 June 2024",
      reportFinalizationDate: "1 June 2024",
    },
    allowableSizeAndGrowth: {
      multiSite: true,
      group: false,
      notApplicableSingleFscCertificate: false,
      sitesToAdd: "",
      growthRate: "",
    },
    additionalInformation: {
      centralOfficeAuditProgram: false,
      note: "*If additional certified locations or expansion beyond the maximum are desired, please contact SCS.",
    },
  },
  Communications: {
    message: "",
  },
  summaryReport: {
    Contact_First_Name__c: null,
    Contact_Surname__c: "Test Gos",
    Street_Address__c: null,
    Email__c: "bindiyaramani@maantic.com",
    Phone_Cell__c: null,
    Status__c: "Customer Review",
    Account_Name__c: "Maruti suzuki",
    Project__r: {
      inspire1__Opportunity1__r: {
        Technical_Specialist__r: {
          Name: "Utkarsh Goswami",
          id: "0058a00000KvVpfAAF",
        },
        Program_Goal__c: "a23VA000004HtsIYAS",
        Programc__r: {
          name: "FSC Chain of Custody",
          id: "a25VA000000AwJhYAK",
        },
        Primary_Contact__r: {
          FirstName: "Umesh",
          LastName: "Kumar",
          Email: "umesh.kumar@maantic.com",
          MailingStreet: null,
          MailingState: null,
          MailingCity: null,
          MailingPostalCode: null,
          id: "003VA00000EiIDkYAN",
        },
        Account: {
          Description:
            "This is testing description for the account. Do not use\r\nThis is testing description for the account. Leave it\r\nThis is testing description for the account. Something not right",
          Website: "www.test.com",
          id: "001VA000008EuHIYA0",
        },
        Standard_Covered_Titles__c: null,
        Bundle_Opportunity__c: "006VA0000064U5lYAE",
        id: "006VA000005xKmFYAU",
      },
      Audit_Date__c: null,
      Due_Date__c: null,
      id: "a0eVA000000lYnpYAE",
    },
    Website__c: "www.test.com",
    Opportunity_Name__c: "GRS Update1 UT Update",
    General_Description__c: null,
    Audit_Type__c: null,
    Auditor_Name__c: null,
    Description_Of_Changes__c: null,
    FSC_STD_Multiple_Sites_Group__c: true,
    FSC_STD_Project_Certification__c: true,
    FSC_STD_Reclaimed_Material__c: true,
    FSC_STD_Controlled_Wood_Sourcing__c: true,
    FSC_STD_Chain_Of_Custody__c: true,
    FSC_STD_Trademark_Use__c: true,
    FSC_Product_Group_List__c: false,
    PGL_FSC_as_seperate_record__c: false,
    FSC_Product_Filename__c: null,
    PEFC_SFI_RW_Product_Categories__c: true,
    Product_List_Comparison_SCS_PEFC__c: "Matched",
    Reclaimed_Materials_Information__c: false,
    Description_of_the_organization_s_verifi__c:
      "Testing verification data for report",
    Multi_Site_Group_Information__c: true,
    Describe_Management_System__c:
      "This is testing multi level test Description Management System",
    Describe_Management_of_non_conformities__c:
      "This is testing multi level test Management of non-conformities",
    Description_Group_Multisite_Level__c: "Display Data",
    Describe_Material_sourcing__c:
      "This is testing multi level test Description Material Sourcing",
    Site_relationships_addition_removal_p__c:
      "This is testing multi level test Site relationships, add/removal process",
    FSC_AAF_Data__c: false,
    FY_Start_Date__c: "2024-12-22T00:00:00",
    FPT_Turnover_Local_Currency__c: 11.0,
    FPT_Local_Currency_Unit__c: 22.0,
    Total_Revenue_USD__c: 33.0,
    FSC_Data_Recent_FY__c: false,
    FY_End_Date__c: "2024-12-26T00:00:00",
    FPT_Turnover_USD__c: 44.0,
    Total_Revenue_Local_Currency__c: 55.0,
    FPT_TR__c: "Financial data is not provided",
    Auditor_Certification_Review_FSC__c: "Initial Certification is recommended",
    Auditor_Certification_Review_PEFC__c: "Re-certification is recommended",
    Auditor_Certification_Review_SFI__c:
      "Initial Certification is not recommended",
    Auditor_Certification_Review_Other__c:
      "Initial Certification is not recommended",
    Auditor_Comments_FSC__c: "11",
    Auditor_Comments_PEFC__c: "66",
    Auditor_Comments_SFI__c: "22",
    Auditor_Comments_Other__c: "77",
    SCS_Certification_Decision_FSC__c: "Continued certification is recommended",
    SCS_Certification_Decision_PEFC__c: "Re-certification is not recommended",
    SCS_Certification_Decision_SFI__c: "Re-certification is recommended",
    SCS_Certification_Decision_Other__c: "Initial Certification is recommended",
    Certification_Decision_s_By__c: null,
    Central_Office_Audit_Program__c: false,
    SCS_Decision_Comments_FSC__c: "33",
    SCS_Decision_Comments_PEFC__c: "88",
    SCS_Decision_Comments_SFI__c: "44",
    SCS_Decision_Comments_Other__c: "345",
    Date_Of_Report_Finalization__c: null,
    Certificate_Type__c: "single FSC certificate",
    Annual_growth_rate__c: 55.0,
    Allowable_Size_Limit__c: "12.0",
    id: "a3LVA000003nzAM2AY",
  },
  isSuccess: true,
  message: null,
};

export const productListData = {
  opportunityCertificates: [
    {
      Opportunity__r: {
        Technical_Specialist__r: {
          Name: "Sneha Pangam",
          id: "005Rb000006fg6HIAQ",
        },
        Program_Goal__c: "a23VA000006S9OJYA0",
        Programc__r: {
          name: "FSC Chain of Custody",
          id: "a25VA000000AwJhYAK",
        },
        Primary_Contact__r: {
          FirstName: null,
          LastName: "BR Contact",
          Email: "bindiya.ramani@maantic.com",
          MailingStreet: null,
          MailingState: null,
          MailingCity: null,
          MailingPostalCode: null,
          id: "003VA00000Kt1klYAB",
        },
        Account: {
          Description:
            "This is testing description for the account. Do not use\r\nThis is testing description for the account. Leave it\r\nThis is testing description for the account. Something not right",
          Website: "www.test.com",
          id: "001VA000008EuHIYA0",
        },
        Standard_Covered_Titles__c: null,
        Bundle_Opportunity__c: "006VA000006uO5qYAE",
        id: "006VA00000FRyCLYA1",
      },
      Opportunity__c: "006VA00000FRyCLYA1",
      Certificate_Number__c: "SCS-COC-700891",
      Controlled_Wood_Number__c: null,
      Program_Membership_Number__c: null,
      Number_of_Sites__c: "0",
      FY_Start_Date__c: null,
      FY_End_Date__c: null,
      Current_Certification_Start_Date__c: null,
      Current_Certification_End_Date__c: null,
      Scope_of_certification__c: null,
      ProgramName__c: "FSC Chain of Custody",
      Certificate__r: {
        ValidFrom__c: null,
        ValidThrough__c: null,
        id: "a22VA000001M945YAC",
      },
      CreatedDate: "2025-02-04T11:59:18+05:30",
      Certified_Products__r: null,
      id: "a2CVA000001PuEX2A0",
    },
    {
      Opportunity__r: {
        Technical_Specialist__r: {
          Name: "Sneha Pangam",
          id: "005Rb000006fg6HIAQ",
        },
        Program_Goal__c: "a23VA000006S9OJYA0",
        Programc__r: {
          name: "FSC Chain of Custody",
          id: "a25VA000000AwJhYAK",
        },
        Primary_Contact__r: {
          FirstName: null,
          LastName: "BR Contact",
          Email: "bindiya.ramani@maantic.com",
          MailingStreet: null,
          MailingState: null,
          MailingCity: null,
          MailingPostalCode: null,
          id: "003VA00000Kt1klYAB",
        },
        Account: {
          Description:
            "This is testing description for the account. Do not use\r\nThis is testing description for the account. Leave it\r\nThis is testing description for the account. Something not right",
          Website: "www.test.com",
          id: "001VA000008EuHIYA0",
        },
        Standard_Covered_Titles__c: null,
        Bundle_Opportunity__c: "006VA000006uO5qYAE",
        id: "006VA00000FRyCLYA1",
      },
      Opportunity__c: "006VA00000FRyCLYA1",
      Certificate_Number__c: "SCS-COC-700862",
      Controlled_Wood_Number__c: null,
      Program_Membership_Number__c: null,
      Number_of_Sites__c: null,
      FY_Start_Date__c: null,
      FY_End_Date__c: null,
      Current_Certification_Start_Date__c: null,
      Current_Certification_End_Date__c: null,
      Scope_of_certification__c: null,
      ProgramName__c: "FSC Chain of Custody",
      Certificate__r: {
        ValidFrom__c: "2024-12-04T00:00:00",
        ValidThrough__c: "2029-12-03T00:00:00",
        id: "a22VA0000015nnVYAQ",
      },
      CreatedDate: "2024-12-20T19:04:59+05:30",
      Certified_Products__r: {
        totalSize: 7,
        done: true,
        records: [
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: null,
            Primary_Activity__c: "Brokers/Traders with physical possession",
            Secondary_Activity__c:
              "Brokers/Traders without physical possession",
            Output_Category__c: "FSC 100%",
            Level_1__c: "N10 Other NTFP n.e.c",
            Level_2__c: null,
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000KcsL2AS",
          },
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: null,
            Primary_Activity__c: "Brokers/Traders with physical possession",
            Secondary_Activity__c: null,
            Output_Category__c: "FSC 100%",
            Level_1__c: "N10 Other NTFP n.e.c",
            Level_2__c: null,
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000KcvZ2AS",
          },
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: null,
            Primary_Activity__c: "Brokers/Traders with physical possession",
            Secondary_Activity__c: null,
            Output_Category__c: "FSC 100%",
            Level_1__c: "N4 Straw, wicker, rattan and similar",
            Level_2__c: "N4.1 Rattan cane (rough form)",
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000KcxB2AS",
          },
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: "!Remove Erisma spp.,.Other - please specify",
            Primary_Activity__c: "Brokers/Traders with physical possession",
            Secondary_Activity__c:
              "Brokers/Traders without physical possession",
            Output_Category__c: "FSC 100%",
            Level_1__c: "N10 Other NTFP n.e.c",
            Level_2__c: null,
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000Kcyn2AC",
          },
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: ".Other - please specify",
            Primary_Activity__c: "Brokers/Traders with physical possession",
            Secondary_Activity__c: "Brokers/Traders with physical possession",
            Output_Category__c: "FSC 100%",
            Level_1__c: "N10 Other NTFP n.e.c",
            Level_2__c: null,
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000KqiP2AS",
          },
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: "152d Fraxinus  pennsylvanica Marsh",
            Primary_Activity__c: "Gathering of non-wood products",
            Secondary_Activity__c: "Gathering of non-wood products",
            Output_Category__c: "FSC Recycled;FSC Controlled Wood",
            Level_1__c: "N2 Soil conditioner and substrates",
            Level_2__c: null,
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000Kqld2AC",
          },
          {
            Certificate__c: "a22VA0000015nnVYAQ",
            Certificate_Number__c: "SCS-COC-700862",
            Related_Species__c: "Septotheca tessmannii",
            Primary_Activity__c: "Distributor/Wholesaler",
            Secondary_Activity__c: null,
            Output_Category__c: "FSC Controlled Wood",
            Level_1__c: "N1 Barks",
            Level_2__c: null,
            Claim__c: null,
            OpportunityCertificate__c: "a2CVA0000018VCX2A2",
            OpportunityCertificate__r: null,
            id: "a2NVA000000Kr092AC",
          },
        ],
      },
      id: "a2CVA0000018VCX2A2",
    },
  ],
  isSuccess: true,
  message: null,
};
